import React, { useCallback, useMemo, useState } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import { useOnDismissDialog } from '../../../analytics/use-on-dismiss-dialog';
import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { PopupEntryPoint } from '../shared/popup-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, EntryPointParams } from './entrypoint';

export const PremiumPopup = () => {
	const { cloudId, product, PremiumWrapper, trialDaysLeft, userRoles } = useEditionAwareness();

	const [isPremiumModalOpen, setIsPremiumModalOpen] = useState(false);
	const handleClosePremiumModal = useCallback(() => setIsPremiumModalOpen(false), []);
	const handleOpenPremiumModal = useCallback(() => setIsPremiumModalOpen(true), []);

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			isConfluence: product === 'confluence',
			cloudId,
			hamsProductKey: getHamsKey(product),
		}),
		[product, cloudId],
	);

	const entryPointProps = useMemo(() => ({ handleOpenPremiumModal }), [handleOpenPremiumModal]);

	const onClose = useOnDismissDialog({ ...DIALOG_CONFIG });

	if (!PremiumWrapper) {
		// Shouldn't happen, but if it does then we can at least still show the customer a dialog
		return (
			<AnalyticsContext data={DIALOG_CONFIG}>
				<PopupEntryPoint
					entryPoint={entryPoint}
					entryPointParams={entryPointParams}
					entryPointProps={entryPointProps}
					placement={'bottom-start'}
					onClose={onClose}
				/>
			</AnalyticsContext>
		);
	}

	return (
		<AnalyticsContext data={DIALOG_CONFIG}>
			<PremiumWrapper
				trialDaysLeft={trialDaysLeft}
				isSiteAdmin={!!userRoles?.includes('SITE_ADMIN')}
				isPremiumModalOpen={isPremiumModalOpen}
				onClosePremiumModal={handleClosePremiumModal}
			>
				<PopupEntryPoint
					entryPoint={entryPoint}
					entryPointParams={entryPointParams}
					entryPointProps={entryPointProps}
					placement={'bottom-start'}
					onClose={onClose}
				/>
			</PremiumWrapper>
		</AnalyticsContext>
	);
};
